<div class="root-body"
     [ngClass]="{
    'root-body-sidebar-slim': configService.config.menuMode === 'sidebar' || configService.config.menuMode === 'slim',
    'root-body-sidebar-static': configService.config.menuMode === 'sidebar' && configService.config.sidebarStatic,
    'root-body-horizontal': configService.config.menuMode === 'horizontal'}">
    <p-toast></p-toast>

    <user-filter *ngIf="visibleUserFilter"
                 [visibleUserFilter]="visibleUserFilter"
                 [customersComponent]="this"
                 [filterObj]="filter"
                 (changedVisibleUserFilterEmit)="changedVisibleUserFilterEmit($event)"></user-filter>

    <suspend-user [userId]="suspendUser.userId" [userName]="suspendUser.userName" [_displayModalSuspend]="displayModalSuspend"
                  (changedDisplayModalSuspendEmit)="changedDisplayModalSuspendEmit($event)"
                  (suspendSuccessEmit)="onCustomerSuspendSuccess()"></suspend-user>

    <p-breadcrumb class="breadcrumb mb-3" [model]="breadcrumbs"></p-breadcrumb>

    <div class="card">
        <p-dialog header="Title" [(visible)]="displayModal" [style]="{width: '70vw'}"
                  [draggable]="false" [resizable]="false">
            <ng-template pTemplate="header">
                Beta features
            </ng-template>
            <p-pickList [source]="betaFeatureSourceList" [target]="betaFeatureTargetList">
                <ng-template let-feature pTemplate="betaFeatur">
                    <div>
                        {{feature}}
                    </div>
                </ng-template>
            </p-pickList>
            <ng-template pTemplate="footer">
                <spinner *ngIf="isLoadingBetaFeature"></spinner>
                <div *ngIf="isShowBtnBetaFeature">
                    <p-button icon="pi pi-check" (click)="saveBetaFeatures()" label="Save" styleClass="p-button-text"></p-button>
                    <p-button icon="pi pi-times" (click)="displayModal=false" label="Cancel" styleClass="p-button-text"></p-button>
                </div>
            </ng-template>
        </p-dialog>

        <div class="onboarding-head">
            <div class="onboarding-head-fleft">
                <div class="onboarding-head-title">
                    {{menuTitleName}}
                </div>
            </div>
            <div class="flex flex-row onboarding-head-right">
                <div>
                    <span class="search-panel-item p-input-icon-left">
                        <i class="pi pi-search"></i>
                        <input pInputText type="text" class="search-input"
                               [(ngModel)]="filter.searchName" (input)="handleHeaderFilterChange($event)"
                               style="width: 280px;"
                               placeholder="Search here..." />
                    </span>
                </div>
                <div class="ml-3" *ngIf="isShowBtnFeatures">
                    <span class="filters-panel-item">
                        <button class="filters-panel-item-button btn-darkblue" pButton label="Beta features"
                                *ngIf="isShowBtnFeatures" (click)="showDisplayModal()"></button>
                    </span>
                </div>
                <div class="ml-3">
                    <button pButton pRipple type="button" label="Filter"
                            class="filters-panel-item-button p-button-outlined p-button-secondary"
                            (click)="openUserFilter()"></button>
                </div>
                <div class="ml-3">
                    <span>
                        <button pButton pRipple type="button" label="Edit Table" class="p-button"
                                style="padding: 10px 20px 10px 20px; "></button>
                    </span>
                </div>
                <div class="ml-4 mt-1">
                    <column-selector #columnSelector
                         [defaultColumns]="defaultCols"
                         (selectedColumnsChange)="onSelectedColumnsChange($event)"
                         [tableName]="menuTitleName"
                         [(selectedColumns)]="cols">
                    </column-selector>
                </div>
            </div>
        </div>

        <p-table #xpressUsersGrid
                 [columns]="cols"
                 [value]="xpressUsers"
                 [lazy]="true"
                 responsiveLayout="scroll"
                 dataKey="Id"
                 (onLazyLoad)="handleLazyLoad($event)"
                 [loading]="loading"
                 [selection]="selectedUsers"
                 (selectionChange)="onSelectionChange($event)"
                 [paginator]="true"
                 [showFirstLastIcon]="false"
                 [(first)]="first"
                 [rows]="rowsPerPage"
                 [totalRecords]="totalRecords"
                 [resizableColumns]="true"
                 [columnResizeMode]="'expand'"
                 [autoLayout]="true"
                 [styleClass]="'p-datatable-gridlines'"
                 [scrollable]="true"
                 [scrollHeight]="'flex'"
                 [style]="{height: 'calc(73vh)'}"
                 [(selection)]="selectedUsers">
            <ng-template pTemplate="caption">
            </ng-template>
            <ng-template pTemplate="header">
                <tr>
                    <th *ngFor="let col of cols"
                        [pSortableColumn]="col.field"
                        [pSortableColumnDisabled]="col.disableSort"
                        pResizableColumn
                        [style.width]="col.width">
                        {{col.header}}
                        <p-sortIcon [field]="col.field" class="onboarding-column-sorticon"></p-sortIcon>
                    </th>
                    <th *ngIf="configService.config.showDeleteUser">Action</th>
                </tr>
                <tr>
                    <ng-container *ngFor="let item of cols">
                        <th class="overflow-unset">
                            <ng-container *ngIf="item.fieldType === fieldTypeEnum.Inputs">
                                <input type="text" pInputText placeholder="{{item.placeholder}}" [(ngModel)]="userHeaderSearch[item.model]"
                                       (input)="handleHeaderFilterChange($event)" />
                            </ng-container>
                            <ng-container *ngIf="item.fieldType === fieldTypeEnum.InputNumber">
                                <p-inputNumber inputId="integeronly" placeholder="{{item.placeholder}}" [(ngModel)]="userHeaderSearch[item.model]"
                                               (ngModelChange)="handleHeaderFilterChange($event)"> </p-inputNumber>
                            </ng-container>
                            <ng-container *ngIf="item.fieldType === fieldTypeEnum.Dropdown">
                                <ng-container *ngIf="item.take === 'obj'; else dropdown">
                                    <p-dropdown [options]="item.options" placeholder="{{item.placeholder}}"
                                                optionLabel="name" [(ngModel)]="userHeaderSearch[item.model]"
                                                (ngModelChange)="handleHeaderFilterChange($event)"></p-dropdown>
                                </ng-container>
                                <ng-template #dropdown>
                                    <p-dropdown [options]="item.options" placeholder="{{item.placeholder}}"
                                                optionLabel="name" optionValue="value" [(ngModel)]="userHeaderSearch[item.model]"
                                                (ngModelChange)="handleHeaderFilterChange($event)"></p-dropdown>
                                </ng-template>
                            </ng-container>
                            <ng-container *ngIf="item.fieldType === fieldTypeEnum.Calendar">
                                <p-calendar [(ngModel)]="userHeaderSearch[item.model]"
                                            [showIcon]="true"
                                            placeholder="{{item.placeholder}}"
                                            dateFormat="dd M yy"
                                            (ngModelChange)="handleHeaderFilterChange($event)" />
                            </ng-container>
                        </th>
                    </ng-container>
                    <th *ngIf="configService.config.showDeleteUser"></th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-xpressUser>
                <tr class="cursor-pointer" [pSelectableRow]="xpressUser" (click)="handlePopupLinkClick(xpressUser, false)">
                    <td class="ui-resizable-column" *ngFor="let item of cols">
                        <ng-container [ngSwitch]="item.field">
                            <ng-container *ngSwitchCase="'StatusText'">
                                <div class="user-status-badge"
                                     [style.color]="xpressUser.StatusColor"
                                     [style.background-color]="xpressUser.StatusBackColor">
                                    {{xpressUser.StatusText}}
                                </div>
                            </ng-container>
                            <ng-container *ngSwitchCase="'TotalSpend'">
                                <span class="onbg-status-col">
                                    {{xpressUser.TotalSpend | currency:'PHP'}}
                                </span>
                            </ng-container>
                            <ng-container *ngSwitchCase="'WasReferred'">
                                <span class="onbg-status-col">
                                    {{(xpressUser.WasReferred) ? 'Yes' : 'No'}}
                                </span>
                            </ng-container>
                            <ng-container *ngSwitchCase="'LastActive'">
                                <span class="onbg-status-col" [ngStyle]="{'color': getLastActiveStyles(xpressUser.LastActiveAt)}">
                                    {{xpressUser.LastActive}}
                                </span>
                            </ng-container>
                            <ng-container *ngSwitchDefault>
                                <span class="user-id-column-value">
                                    {{xpressUser[item.field]}}
                                </span>
                            </ng-container>
                        </ng-container>
                    </td>
                    <td *ngIf="configService.config.showDeleteUser">
                        <span (click)="handleRemoveUserPopup(xpressUser)">
                            <img src="\Content\xpress-app\images\svg\icon_trash.svg" />
                        </span>
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="paginatorleft" let-state>
                <div *ngIf="xpressUsers.length > 0" style="padding-left: 10px">
                    Showing {{first + 1}} to {{first + xpressUsers.length}} of {{totalRecords}} entries
                </div>
            </ng-template>
        </p-table>
    </div>
</div>
<p-dialog header="Remove User" [(visible)]="showRemoveUserPopup" [modal]="true" [style]="{width: '400px'}"
          [draggable]="false" [resizable]="false">
    <p class="m-0">
        Do you really want to delete user {{selectedCustomer ? selectedCustomer.UserName : ""}}?<br>
        Warning: This action cannot be undone!
    </p>
    <ng-template pTemplate="footer">
        <p-button icon="pi pi-times" (click)="showRemoveUserPopup=false" label="Cancel" styleClass="p-button-text"></p-button>
        <p-button icon="pi pi-trash" [disabled]="loading" (click)="removeUser()" label="Remove" styleClass="p-button-text"></p-button>
    </ng-template>
</p-dialog>
<customer-info *ngIf="isVisibleCustomerInfo"
               [isVisibleCustomerInfo]="isVisibleCustomerInfo"
               [_customerId]="infoPopupCustomer.Id"
               [showEditFields]="showEditFields"
               [showLogsRequest]="true"
               (changedVisibleCustomerInfoEmit)="changedVisibleCustomerInfoEmit($event)"
               (suspendSuccessEmit)="onCustomerSuspendSuccess()"
               (banSuccessEmit)="onCustomerBanSuccess()"
               (liftSuspensionSuccessEmit)="onCustomerLiftSuspensionSuccess()"
               (liftBanSuccessEmit)="onCustomerLiftBanSuccess()"></customer-info>
